export enum LanguageEnum {
  DA = 'da',
  NO = 'no',
  NB = 'no',
  NN = 'no',
  SV = 'sv',
  FI = 'fi',
  EN = 'en'
}
